module.exports = __webpack_public_path__ + "img/loader_circle.8d98bd8e.svg";